(function () {
  'use strict';

  function initSlider(section) {
    const sectionId = section.id.replace('mm-testimonials-', '');
    const wrapper   = section.querySelector('.mm-testimonials__slider');
    const inner     = wrapper ? wrapper.querySelector('.swiper-wrapper') : null;
    const slides    = inner ? Array.from(inner.querySelectorAll('.swiper-slide')) : [];
    const prevBtn   = section.querySelector('.mm-prev-' + sectionId);
    const nextBtn   = section.querySelector('.mm-next-' + sectionId);

    if (!wrapper || !inner || slides.length === 0 || !prevBtn || !nextBtn) return;

    const total = slides.length;
    let current = 0;
    let isAnimating = false;

    function getCSSVar(name, fallback) {
      const val = parseFloat(getComputedStyle(section).getPropertyValue(name));
      return isNaN(val) ? fallback : val;
    }

    function isMobile() { return window.innerWidth < 750; }
    function mod(n, m) { return ((n % m) + m) % m; }

    function render(instant) {
      const inactiveScale   = getCSSVar('--mm-inactive-scale', 0.88);
      const inactiveOpacity = getCSSVar('--mm-inactive-opacity', 0.55);
      const wrapperW = wrapper.offsetWidth;

      inner.style.position = 'relative';
      wrapper.style.overflow = 'hidden';

      if (isMobile()) {
        // ── Mobile ──────────────────────────────────────────────────────────────
        let activeH = 0;

        slides.forEach(function (slide, i) {
          const offset = mod(i - current, total);
          const isActive = offset === 0;

          // Kill transition on hidden slides before moving them
          if (!isActive) {
            slide.style.transition = 'none';
            slide.style.visibility = 'hidden';
          }

          slide.style.position = 'absolute';
          slide.style.top      = '0';
          slide.style.left     = '0';
          slide.style.width    = '100%';

          if (isActive) {
            slide.style.transition  = instant ? 'none' : 'opacity 0.35s ease';
            slide.style.visibility  = 'visible';
            slide.style.opacity     = '1';
            slide.style.zIndex      = '2';
            slide.style.transform   = 'none';
            slide.classList.add('swiper-slide-active');
            activeH = slide.querySelector('.mm-testimonials__card').offsetHeight;
          } else {
            slide.style.opacity   = '0';
            slide.style.zIndex    = '0';
            slide.style.transform = 'none';
            slide.classList.remove('swiper-slide-active');
          }
        });

        if (activeH > 0) inner.style.height = activeH + 'px';

      } else {
        // ── Desktop ─────────────────────────────────────────────────────────────
        const gap     = 20;
        const activeW = Math.round(wrapperW * 0.44);
        const sideW   = Math.round((wrapperW - activeW - gap * 2) / 2);
        const center  = wrapperW / 2;

        let maxH = 0;

        slides.forEach(function (slide, i) {
          const offset   = mod(i - current, total);
          const isActive = offset === 0;
          const isLeft   = offset === mod(-1, total);
          const isRight  = offset === 1;
          const isVisible = isActive || isLeft || isRight;

          // Kill transition before repositioning hidden slides
          if (!isVisible) {
            slide.style.transition  = 'none';
            slide.style.visibility  = 'hidden';
          }

          slide.style.position = 'absolute';
          slide.style.top      = '0';

          if (isActive) {
            slide.style.transition  = instant ? 'none' : 'transform 0.45s ease, opacity 0.45s ease, width 0.45s ease, left 0.45s ease';
            slide.style.visibility  = 'visible';
            slide.style.width       = activeW + 'px';
            slide.style.left        = (center - activeW / 2) + 'px';
            slide.style.transform   = 'scale(1)';
            slide.style.opacity     = '1';
            slide.style.zIndex      = '3';
            slide.classList.add('swiper-slide-active');
          } else if (isRight) {
            slide.style.transition  = instant ? 'none' : 'transform 0.45s ease, opacity 0.45s ease, width 0.45s ease, left 0.45s ease';
            slide.style.visibility  = 'visible';
            slide.style.width       = sideW + 'px';
            slide.style.left        = (center + activeW / 2 + gap) + 'px';
            slide.style.transform   = 'scale(' + inactiveScale + ')';
            slide.style.opacity     = String(inactiveOpacity);
            slide.style.zIndex      = '2';
            slide.classList.remove('swiper-slide-active');
          } else if (isLeft) {
            slide.style.transition  = instant ? 'none' : 'transform 0.45s ease, opacity 0.45s ease, width 0.45s ease, left 0.45s ease';
            slide.style.visibility  = 'visible';
            slide.style.width       = sideW + 'px';
            slide.style.left        = (center - activeW / 2 - gap - sideW) + 'px';
            slide.style.transform   = 'scale(' + inactiveScale + ')';
            slide.style.opacity     = String(inactiveOpacity);
            slide.style.zIndex      = '2';
            slide.classList.remove('swiper-slide-active');
          } else {
            slide.style.opacity    = '0';
            slide.style.zIndex     = '0';
            slide.classList.remove('swiper-slide-active');
          }

          if (isVisible) {
            const card = slide.querySelector('.mm-testimonials__card');
            if (card && card.offsetHeight > maxH) maxH = card.offsetHeight;
          }
        });

        if (maxH > 0) inner.style.height = maxH + 'px';
      }
    }

    function goTo(index) {
      if (isAnimating) return;
      isAnimating = true;
      current = mod(index, total);
      render(false);
      setTimeout(function () { isAnimating = false; }, 480);
    }

    prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); });

    let touchStartX = 0, touchStartY = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    wrapper.addEventListener('touchend', function (e) {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { render(true); }, 120);
    });

    render(true);
  }

  function initAll() {
    document.querySelectorAll('.mm-testimonials').forEach(function (section) {
      if (section.dataset.mmSliderInit) return;
      section.dataset.mmSliderInit = '1';
      initSlider(section);
    });
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.mm-testimonials');
    if (section) {
      delete section.dataset.mmSliderInit;
      initSlider(section);
    }
  });

  document.addEventListener('shopify:section:reorder', initAll);

})();